import React, { useEffect } from "react";
import styled from "styled-components";
import notFound from "../images/notFound.svg";
import { Link, useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      navigate("/");
    }, 3000);
  }, [navigate]);
  return (
    <>
      <Container>
        <div className="overlay"></div>
        <div className="message">
          <h1>Page not found</h1>

          <Link to="/"> Return home</Link>
        </div>
      </Container>
    </>
  );
};

export default NotFound;

const Container = styled.main`
  width: 100%;
  height: clamp(60vh, 80vh, 100vh);
  margin-top: 5rem;
  background-image: url(${notFound});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;

  .overlay {
    width: 100%;
    height: 100%;
    display: grid;
    place-content: center;
    text-align: center;
    line-height: 2rem;
    color: red;
    font-weight: bold;
    background: black;
    opacity: 0.7;
  }

  .message {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);

    h1 {
      text-transform: uppercase;
    }

    a {
      text-transform: uppercase;
      text-decoration: none;
      color: ${(props) => props.theme.dark.custom};
      font-weight: bold;
      font-size: clamp(0.5rem, 1rem, 1.5rem);
      transition: all 0.3s;
    }
  }
`;
